import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { GetPaymentInvoiceURL } from "../../stores/orders";
import { CircularProgress } from "@mui/material";
import { setToast } from "../../stores/toast/toastslice";

const PayInvoice = () => {
  const { token } = useParams();
  const [loading] = useState(true);

  const dispatch = useDispatch();

  const fetchPaymentURL = async () => {
    try {
      const res = await dispatch<any>(
        GetPaymentInvoiceURL({ token: token || "" }),
      ).unwrap();

      if (res?.status >= 400) {
        await dispatch<any>(
          setToast({
            message: res?.data?.message,
            type: "error",
            title: "Error",
          }),
        );
        const timeout = setTimeout(() => {
          window.location.href = window.location.origin;
        }, 2000);

        return () => clearTimeout(timeout);
      }

      if (res?.data?.payment_link) {
        window.location.href = res?.data?.payment_link;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchPaymentURL();
    }
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <div
            style={{ textAlign: "center", marginTop: "5px", color: "#747474" }}
          >
            Redirecting to the payment page...
          </div>
        </div>
      </div>
    );
  }

  return <div>PayInvoice</div>;
};

export default PayInvoice;
